<template>
    <div class="home">
        <div class="top-box d_flex">
            <div class="item-box">
                <div class="left-box">
                    <i class="el-icon-s-custom"></i>
                </div>
                <div class="right-box">
                    <h3>会员数量</h3>
                    <p>{{iData.member_total}}<span>人</span></p>
                </div>
            </div>
            <div class="item-box">
                <div class="left-box bg_col1">
                    <i class="el-icon-s-flag"></i>
                </div>
                <div class="right-box">
                    <h3>场地总数</h3>
                    <p>{{iData.space_total}}<span>个</span></p>
                </div>
            </div>
            <div class="order-box">
                <div class="con">
                    <div class="title">订单实时情况</div>
                    <div class="list d_flex j_b">
                        <div class="l">
                            <p class="tit">订单数量</p>
                            <p class="val" v-if="iData.order">{{iData.order.num}}<span>条</span></p>
                        </div>
                        <div class="r">
                            <p class="tit">累计收入</p>
                            <p class="val"  v-if="iData.order">{{iData.order.amount}}<span>元</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="message-box">
            <h2>待办事项</h2>
            <div class="msg-list">
                <div class="msg-item d_flex a_c" v-if="(role_id!=4||(role_id==4&&hasSiteCheck))&&iData.audit">
                    <div class="icon"><i class="el-icon-s-check"></i></div>
                    <div class="con">
                        <p v-if="iData.audit.space_num>0">共<span>{{iData.audit.space_num}}</span>条场地审核消息</p>
                        <p v-else class="tip">没有需要处理的场地审核噢！</p>
                    </div>
                    <div class="btn-box">
                        <el-button type="primary" :disabled="iData.audit.space_num==0" @click="toSpace">去处理</el-button>
                    </div>
                </div>
                <div class="msg-item d_flex a_c"  v-if="(role_id!=4||(role_id==4&&hasServiceCheck))&&iData.audit">
                    <div class="icon"><i class="el-icon-s-check"></i></div>
                    <div class="con">
                        <p v-if="iData.audit.service_num>0">共<span>{{iData.audit.service_num}}</span>条服务商审核消息</p>
                        <p v-else class="tip">没有需要处理的服务商审核噢！</p>
                    </div>
                    <div class="btn-box">
                        <el-button type="primary" :disabled="iData.audit.service_num==0" @click="toService">去处理</el-button>
                    </div>
                </div>
                <div class="msg-item d_flex a_c"  v-if="iData.audit&&userinfo.user_type==1">
                    <div class="icon"><i class="el-icon-s-check"></i></div>
                    <div class="con">
                        <p v-if="iData.audit.bank_num>0">共<span>{{iData.audit.bank_num}}</span>条提现审核消息</p>
                        <p v-else class="tip">没有需要处理的提现申请噢！</p>
                    </div>
                    <div class="btn-box">
                        <el-button type="primary" :disabled="iData.audit.bank_num==0" @click="toWithdraw">去处理</el-button>
                    </div>
                </div>
                <div class="msg-item d_flex a_c"  v-if="(role_id!=4||(role_id==4&&hasReqCheck))&&iData.audit">
                    <div class="icon"><i class="el-icon-s-check"></i></div>
                    <div class="con">
                        <p v-if="iData.space_booking>0">共<span>{{iData.space_booking}}</span>条需求消息</p>
                        <p v-else class="tip">没有需要处理的需求噢！</p>
                    </div>
                    <div class="btn-box">
                        <el-button type="primary" :disabled="iData.space_booking==0" @click="toRequire">去处理</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="chart-box">
            <h2>场地统计</h2>
            <div class="main-chart" ref="main" id="main"></div>
        </div>
        <div class="chart-box">
            <h2>用户统计</h2>
            <div class="main-chart" ref="main1" id="main1"></div>
        </div>
    </div>
</template>

<script>
    import {getHome} from "../../api/index";

    export default {
        name: "home",
        data(){
            return{
                charts: '',
                option:{},
                iData:'',
                userinfo:'',
                role_ads:[],
                hasSiteCheck:false,
                hasServiceCheck:false,
                hasReqCheck:false,
                role_id:0,
            }
        },
        mounted(){
            this.getHome();
            this.role_id=localStorage.getItem('ROLE');
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            this.role_ads=JSON.parse(localStorage.getItem('USERINFO')).role_adm_access_ids;
            if(this.role_ads.length>0){
                this.hasSiteCheck= this.role_ads.includes('20');
                this.hasServiceCheck= this.role_ads.includes('26');
                this.hasReqCheck= this.role_ads.includes('35');
            }
        },
        methods:{
            toSpace(){
              this.$router.push({path:'/site/site'})
                this.$emit('changeRouter',{id:5,url:'/site/site',icon:'el-icon-s-grid',name:'场地管理',isShow:true})
            },
            toService(){
                this.$router.push({path:'/service/service'})
                this.$emit('changeRouter',{id:6,url:'/service/service',icon:'el-icon-s-custom',name:'服务商管理',isShow:true})
            },
            toWithdraw(){
                this.$router.push({path:'/withdraw/withdraw'})
                this.$emit('changeRouter',{id:9,url:'/withdraw/withdraw',icon:'el-icon-s-finance',name:'财务管理',isShow:true})
            },
            toRequire(){
                this.$router.push({path:'/demand/demand'});
                this.$emit('changeRouter',{id:9,url:'/demand/demand',icon:'el-icon-circle-plus',name:'需求管理',isShow:true})
            },
            getHome(){
                getHome().then(res=>{
                    if(res.code==1){
                        this.iData=res.data;
                        let options=res.data.space_echarts;
                        let options1=res.data.user_echarts;
                        let data1=[],data2=[];
                        options.map(val=>{
                            data1.push(val.date);
                            data2.push(val.num);
                        })
                        let data3=[],data4=[];
                        options1.map(val=>{
                            data3.push(val.date);
                            data4.push(val.num);
                        })
                        this.$nextTick(function() {
                            this.drawPie(data1,data2)
                            this.drawPie1(data3,data4)
                        })
                    }
                })
            },
            drawPie(data1,data2){
                let  myChart = this.$echarts.init(this.$refs.main);
                myChart.setOption(
                    {
                        tooltip: {
                            trigger: 'axis'
                        },
                        xAxis: {
                            type: 'category',
                            data: data1
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                data: data2,
                                type: 'line',
                                smooth: true
                            }
                        ]
                    }
                )
            },
            drawPie1(data1,data2){
                let  myChart = this.$echarts.init(this.$refs.main1);
                myChart.setOption(
                    {
                        xAxis: {
                            type: 'category',
                            data: data1
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                data: data2,
                                type: 'bar',
                                showBackground: true,
                                backgroundStyle: {
                                    color: 'rgba(180, 180, 180, 0.2)'
                                }
                            }
                        ]
                    }
                )
            }
        }
    }
</script>

<style scoped lang="scss">
.home{
    padding: 20px;
    .top-box{
        width: 100%;
        height: 160px;
        margin-bottom: 20px;
        .item-box{
            padding: 20px 30px;
            display: flex;
            align-items: center;
            width: 30%;
            min-width:  300px!important;
            border-radius: 4px;
            min-height: 80px;
            background-color: #fff;
            margin-right: 20px;
            border: 1px solid #edf1f7;
            .left-box{
                width: 60px;
                height: 60px;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: linear-gradient(116deg,#4a95ff,#63c0fa);
                color: #ffffff;
                font-size: 30px;
                margin-right: 20px;
            }
            .right-box{
                h3{
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                }
                p{
                    font-size: 24px;
                    font-weight: bold;
                    color: #333333;
                    span{
                        font-size: 14px;
                        color: #666666;
                    }
                }
            }
        }
        .order-box{
            width: 39%;
            min-width: 350px;
            min-height: 80px;
            background-color: #fff;
            border: 1px solid #edf1f7;
            padding: 20px 30px;
            .title{
                text-align: left;
                margin-bottom: 10px;
            }
            .list{
                .tit{
                    color: #666666;
                    font-size: 14px;
                }
                .val{
                    font-size: 20px;
                    font-weight: bold;
                    span{
                        font-size: 14px;
                        color: #666666;
                        margin-left: 5px;
                    }
                }
            }
        }
    }
    .message-box{
        background-color: #fff;
        width: 100%;
        padding: 20px 30px;
        border: 1px solid #edf1f7;
        h2{
            text-align: left;
            margin-bottom: 10px;
        }
        .msg-list{
            .msg-item{
                padding: 20px 0;
                .icon{
                    font-size: 40px;
                    color: #4890f7;
                    margin-right: 10px;
                }
                .con{
                    flex: 1;
                    text-align: left;
                    font-size: 18px;
                    p{
                        span{
                            color: #f00;
                            font-weight: bold;
                            margin: 0 5px;
                        }
                        &.tip{
                            margin-top: 10px;
                            color: #666666;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
    .chart-box{
        margin-top: 20px;
        background-color: #fff;
        padding-top: 20px;
        h2{
            font-size: 24px;
            text-align: left;
            padding-left: 30px;
        }
        .main-chart{
            width: 100%;
            height: 400px;
        }
    }

}
</style>
